module.exports = __webpack_public_path__ + "img/tcndxq_img6_gray-6.ae8d0319.png";